import React from 'react';

const GeneroContext = React.createContext();

export default GeneroContext;